import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

// Pipe "impure" (pure:false) : Angular le reevalue a chaque cycle de detection de changement,
// ce qui est necessaire ici pour que le texte se mette a jour immediatement quand on change
// de langue (FR/EN/AR) sans avoir a recharger la page.
@Pipe({
  name: 'traduire',
  pure: false
})
export class TraduirePipe implements PipeTransform {

  constructor(private translationService: TranslationService) { }

  transform(cle: string): string {
    return this.translationService.traduire(cle);
  }
}
